import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams  } from "react-router-dom";
import Layout from '../../parts/Layout';
import { httpRequest } from '../../../services/httpService';
import helpers from '../../../services/helpers';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import DropDownSelection from '../../elements/DropDownSelection';

import Dropdown from 'react-bootstrap/Dropdown'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import initTreeView from '../../../services/initTreeView';
import store from '../../../services/store';
import { productUnitsStatus } from '../../../services/serviceHubStore';

import {getEnums, getData, getApiData, postApiData } from '../../../services/apiService';
import { TbChecklist, TbCalendar , TbEdit, TbTrash, TbFileTypePdf  } from "react-icons/tb";
import { MdHandyman } from "react-icons/md";
 
export default function ProductUnitList ({viewer = 'admin', parent_text = "", home_page = "product-unit"}){
    const { contact_id } = useParams();
    const [record_data, setRecordData] = useState([]);
    const [loading, setLoading] = useState(1);
    const [enums, setEnums] = useState(store.order_enums);
    const [search_key, setSearchKey] = useState('');
    const [prompt_modal, setPromptModal] = useState(0);
    const [prompt_title, setPromptTitle] = useState('');
    const [prompt_caption, setPromptCaption] = useState('');
    const [prompt_error, setPromptError] = useState('');
    const [reasons_list, setResons] = useState();
    const [selected_reason, setSelectedReason] = useState('');
    const [order_id, setOrderID] = useState('');
    const [page_title, setPageTitle] = useState('PolarCare Units');
    const [menu, setMenu] = useState('manage-product-units');
    const [data_table, setDataTable] = useState([]);
    const [selected_items, setSelectedItems] = useState([]);
    const [selected_all, setSelectAll] = useState(false);
    const [datatable_state, setDataTableState] = useState({
        first: 0,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null
    });
    const [filters, setFilters] = useState({
        status: "",
        search: ""
    });
    const [home_link, setHomeLink] = useState("");

    useEffect(() => {
        initTreeView()
        fetchData({
            "page": datatable_state.page + 1,
            "per_page": datatable_state.rows
        })
        
        if(contact_id){
            setPageTitle('Customer Product Units')
            setMenu('manage-customers')
        }

        const status = helpers.getURLParams('status')
        
        if(status){
            setFilters(prev => ({
                ...prev,
                status: status
            }));
        }
        // const fetchEnums = async () => {
        //     setLoading(true)
        //     const data = await getEnums('V1/enums/orders?only=cancellation_reasons')
        //     setResons(data)
        //     setLoading(false)
        // }
        // fetchEnums()
    }, []);

    useEffect(() => {
        displayDataTable(record_data)
    }, [datatable_state.sortOrder]);

    useEffect(() => {
        displayDataTable(record_data)
    }, [
        selected_items, 
        selected_all,
        home_link
    ]);

    useEffect(() => {
        fetchData({
            "page": datatable_state.page + 1,
            "per_page": datatable_state.rows,
            //"search": search_key
        })
    }, [datatable_state, filters]);
    
    function inputChange(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;

                if(name == 'warranty_status') value = 'active'
            } else {
                value = 0;

                if(name == 'warranty_status') value = 'expired'
            }
        }
        else if (e.target.type === "file") {
          value = e.target.files[0]
        }

        let new_state = { [name]: value }

        setFilters({ ...filters, ...new_state });
    }

    async function fetchData(condition = {
        "page": '',
        "search": '',
        "per_page": ''
    }){
        const page = condition.page ?? datatable_state.page
        const per_page = condition.per_page ?? datatable_state.rows
        const search = condition.search ?? search_key
        const status = helpers.getURLParams('status')

        //let filter = `?store_id=${helpers.getStoreID()}&`
        let filter = `?paginate=1&`

        if(page){
            filter += 'page='+page+'&'
        }
        if(per_page){
            filter += 'per_page='+per_page+'&'
        }
        if(filters.search){
            filter += 'search='+filters.search+'&'
        }
        if(filters.status){
            filter += 'status='+filters.status+'&'
        }
        if(contact_id){
            filter += 'customer_id='+contact_id+'&'
        }
        if(status){ 
            filter += `status=${status}&`
        }

        filter = filter.slice(0, -1)

        let endpoint = helpers.createServiceHubUrl(`v1/product-details${filter}`)

        // setLoading(1)
        const data = await getApiData(endpoint)

        if(data){
            setLoading(0)
            setRecordData(data)
            displayDataTable(data)
        }
    }

    async function deleteItem(ids){
        let endpoint = helpers.createServiceHubUrl(`v1/product-details/delete`)
        const res = await postApiData(endpoint, {"ids": ids})

        if(res.status === 'success'){
            fetchData()
            setSelectedItems([])

            Swal.fire({
                title: "Success",
                text: res.message,
                icon: "success",
                confirmButtonText: "OK",
            })
        }
                
        if(res.status === 'error'){
            setSelectedItems([])

            Swal.fire({
                text: res.message,
                //text: err.message,
                icon: "error",
                confirmButtonText: "OK",
            })
        }
    }
    

    function search(e){
        let { value } = e.target;
        setSearchKey(value)
        fetchData({
            "page": datatable_state.page + 1,
            "search": value
        })
    }

    function triggerAction(data = '', action = '', status = ''){
        if(action === 'sent' || action === 'draft'){
            updateStatusItem(data, status)
        }
        else{
            let ids = [];
            if(action === 'single-delete'){
                ids.push(data.id)
            }
            else{
                ids = data.map(o => o['id']);
            }

            let title = 'Delete Product Unit'
            if(ids.length > 1){
                title = 'Delete Invoices'
            }

            Swal.fire({
                title: title,
                text: 'This action cannot be reversed. All associated records will also be deleted. Do you want to continue?',
                showCancelButton: true,
                showConfirmButton: false,
                closeOnCancel: true,
                showDenyButton: true,
                denyButtonText: 'Yes'
            })
            .then((result) => {
                if (result.isDenied) {
                    deleteItem(ids)
                }
            })
        }
    }

    function updateStatusItem(id, status_id){
        const url = helpers.createUrl('V1/manage/polarserv/product-units/status')
        httpRequest(url, 'POST', {
            postdata: {
                "invoice_id": id,
                "store_id": helpers.getStoreID(),
                "status_id": status_id
            },
        }, true)
            .then((res) => {
                setLoading(0)
                fetchData({
                    "page": datatable_state.page + 1,
                    "per_page": datatable_state.rows,
                    "search": search_key
                })
                setSelectedItems([])

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                setSelectedItems([])

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }


    function displayDataTable(data){
        setDataTable(
            <DataTable 
                className='border-top'
                dataKey={data?.id}
                value={data?.data} 
                size="normal"
                paginator 
                rows={data?.per_page} 
                rowsPerPageOptions={[5, 10, 20, 25, 50]}
                totalRecords={data?.total}
                onPage={onPage}
                first={datatable_state.first}
                lazy
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                selection={selected_items} 
                onSelectionChange={onSelectItem}
                scrollHeight="500px"
                scrollable
                responsive={true}
                emptyMessage="No data to display"
            >
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                <Column className="text-right" body={displayActionMenu}></Column> 
                <Column field="status" header="Status" body={({status}) => <h5>{helpers.displayProductUnitStatusBadge(status)}</h5>} />
                <Column field="id" header="ID" />
                <Column field="qr_code" header="QR&nbsp;Code" />
                <Column field="brand" header="Brand" />
                <Column field="model" header="Model" body={({model})=> model ? model : '---'}  />
                <Column field="indoor_serial" header="Indoor&nbsp;Serial" body={({indoor_serial})=> indoor_serial ? indoor_serial : '---'} />
                <Column field="outdoor_serial" header="Outdoor&nbsp;Serial" body={({outdoor_serial})=> outdoor_serial ? outdoor_serial : '---'} />
                <Column field="customer_name" header="Owner" body={({customer_id, customer_name})=> <Link to={`/customers/${customer_id}/edit`}>{customer_name}</Link>}></Column>
                {/* <Column field="invoice_no" header="Invoice&nbsp;No" body={({invoice_id, invoice_no})=> invoice_id ? <Link to={`/invoices/${invoice_id}`}>{invoice_no}</Link> : invoice_no ? invoice_no : '---'} /> */}
                {/* <Column field="purchased_date" header="Date&nbsp;Purchased" /> */}
                {/* <Column field="cleaning_cycle_days" header="Cleaning&nbsp;Cycle&nbsp;Days" /> */}
            </DataTable>
        )

    }

    function getTotal(data){
        let total_amount = data.total_amount ?? 0;
        
        if(!total_amount){
            Object.entries(data.items).map(([key, data]) => {
                const unit_price = parseFloat(data['unit_price'])
                const qty = parseInt(data['quantity'])

                total_amount += unit_price * qty;
            });
        }

        return <>&#8369;{helpers.formatAmount(total_amount)}</>
    }

    const onPage = (e) => {
        setDataTableState(e)
        setSelectedItems([])
    };

    const onSelectItem = (e) => {
        const value = e.value;
        setSelectedItems(value);
    };

    function displayActionMenu(data){
        const balance = parseFloat(data.balance_amount)

        return (<Dropdown>
                        <Dropdown.Toggle className='btn-light border' size="sm" id={"dropdown-actions-"+data.id}>Action</Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                            {
                                home_page === 'contact' ?
                                <Dropdown.Item key="edit" as={Link}  to={`/customers/${contact_id}/product-units/${data.id}/form`}><TbEdit size={20} className='mr-2' />Details</Dropdown.Item> :
                                <Dropdown.Item key="edit" as={Link}  to={`/polarserv/product-units/${data.id}/form`}><TbEdit size={20} className='mr-2' />Details</Dropdown.Item>
                            }

                            <Dropdown.Item key="service-request" as={Link}  to={`/polarserv/service-requests/new?ProductUnit=${data.id}`}><MdHandyman size={20} className='mr-2' />New Service</Dropdown.Item>
                            
                            { (data.status_id != 3 && data.status_id != 4)  ?
                            <>
                            {/* <Dropdown.Divider /> */}
                            <Dropdown.Item key="delete" className='text-danger' onClick={(e) => triggerAction(data, 'single-delete')}><TbTrash size={20} className='mr-2' />Delete</Dropdown.Item>
                            </>
                             : ''}
                        </Dropdown.Menu>
                    </Dropdown>)
    }

    function closeModal(){
        setPromptModal(0)
        setOrderID('')
        setPromptTitle('')
        setPromptCaption('')
        setSelectedReason('')
        setPromptError('')
    }

    function cancelOrder(){
        setPromptError('')
        if(!selected_reason){
            setPromptError('Cancellation reason is required')
            return;
        }
        setPromptModal(0)
        setLoading(1)
        const url = helpers.createUrl('V1/manage/order/polarserv/product-units/status')

        httpRequest(url, 'POST', {
            postdata: {
                "order_id": order_id,
                "store_id": helpers.getStoreID(),
                "status_id": 4,
                "cancel_reason_id": selected_reason
            },
        }, true)
            .then((res) => {
                setLoading(0)
                fetchData()
                // let id = order_id;
                // if(!order_id){
                //     id = res.id
                // }

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                
                if(err.data){
                    //setErrors( err.data );
                }else{
                    //setErrors([])
                }

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    return (
        <Layout parent_text={parent_text} page_title={page_title} menu={menu}>
            <Modal show={prompt_modal}>
                <Modal.Header>
                    <h5>{prompt_title}</h5>
                    <Button variant="danger" size="sm" onClick={closeModal}><i className="fas fa-times"></i></Button>
                </Modal.Header>
                <Modal.Body  style={{position: 'relative'}}>
                    <div className="row">
                        <div className="col-12 form-group">
                            {prompt_caption}

                            <DropDownSelection
                                tagClass="form-control"
                                id="selected_reason"
                                name='selected_reason' 
                                placeholder='Select Cancellation Reason'
                                value={selected_reason}  
                                onChange={(e) => setSelectedReason(e.target.value)}
                                onFocus=""
                                optionList={reasons_list}
                                optionProps ={{value:'id', label:'reason'}}
                                label={<>Reason <span className='text-danger'>*</span></>}
                            />
                            <div className='text-danger' style={{fontSize: '.9rem'}}>{prompt_error}</div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={cancelOrder}>
                        Proceed
                    </Button>
                    <Button variant="secondary" onClick={closeModal}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>

            <div className="container-fluid" style={{position: 'relative'}}>
                    <Loader isLoading={loading}/>
                <div className="card">
                    <div className="card-header border-bottom-0">
                        <div className="row">
                            <div className="col-lg-6 mb-2">
                                <div className="row">
                                    {/* <div className="col-lg-4 mb-3 mb-lg-0">
                                        <DropDownSelection
                                            tagClass="form-control"
                                            id="status"
                                            name='status' 
                                            placeholder='Select Status'
                                            value={filters.status}  
                                            onChange={inputChange}
                                            onFocus=""
                                            optionList={enums?.order_status}
                                            optionProps ={{value:'id', label:'invoice_status'}}
                                        />
                                    </div> */}
                                    <div className="col-lg-4 mb-3 mb-lg-0">
                                        <DropDownSelection
                                            tagClass="form-control"
                                            id="status"
                                            name='status' 
                                            placeholder='Select Status'
                                            value={filters.status}  
                                            onChange={inputChange}
                                            onFocus=""
                                            optionList={productUnitsStatus}
                                            optionProps ={{value:'id', label:'label'}}
                                        />
                                    </div>
                                    <div className="col-lg-6">
                                        <input type="text" name="search" className="form-control" placeholder="Search" onChange={inputChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 text-right mt-3 mt-md-0">
                                {
                                    contact_id ?
                                    <Link className='btn btn-outline-dark float-right' to="/customers/list">Back to Contact List</Link> : 
                                    <Link className='btn btn-primary float-right' to="/polarserv/product-units/new"><i className="fas fa-plus-circle mr-2" />New</Link>
                                }
                                
                                
                                {selected_items.length ?
                                <Dropdown className='float-right mr-3'>
                                    <Dropdown.Toggle className='btn-light border' id={"dropdown-actions-"}>Bulk Action</Dropdown.Toggle>
                                    <Dropdown.Menu align="end">
                                        <Dropdown.Item key="delete" className='text-danger' onClick={(e) => triggerAction(selected_items, 'bulk-delete')}><TbTrash size={20} className='mr-2' />Delete</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> : ''}
                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        { data_table }
                    </div>
                </div>
            </div>
        </Layout>
    )
}